import React from "react";

/**
 * Gamma Trade logo — stylised γ glyph in violet neon. The dark background
 * panel is optional — pass `withFrame={false}` to render the glyph alone on
 * a transparent background (e.g., inside the header).
 *
 * Sizes in pixels via the `size` prop (default 28). Inherits text color
 * for SR-only fallback.
 *
 * Brand: #A855F7 family (violet neon).
 */
const Logo = ({ size = 28, withFrame = true, glow = false, className = "" }) => {
  const id = React.useId();
  const w = size;
  const h = size;
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 64 64"
      className={`shrink-0 ${className}`}
      aria-label="Gamma Trade"
      role="img"
    >
      <defs>
        <linearGradient id={`g-violet-${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#C084FC" />
          <stop offset="100%" stopColor="#A855F7" />
        </linearGradient>
        <linearGradient id={`g-violet-deep-${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#A855F7" />
          <stop offset="100%" stopColor="#7E22CE" />
        </linearGradient>
        {glow && (
          <filter id={`g-glow-${id}`} x="-30%" y="-30%" width="160%" height="160%">
            <feGaussianBlur stdDeviation="0.8" />
          </filter>
        )}
      </defs>
      {withFrame && (
        <rect
          width="64"
          height="64"
          rx="14"
          ry="14"
          fill="#0a0a0c"
          stroke="rgba(168,85,247,0.25)"
          strokeWidth="1"
        />
      )}
      <g
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        filter={glow ? `url(#g-glow-${id})` : undefined}
      >
        {/* Left curve descending (violet) */}
        <path
          d="M 18 18 Q 26 13, 32 20 Q 38 27, 32 35 L 28 44 Q 25 50, 22 52"
          stroke={`url(#g-violet-${id})`}
          strokeWidth="5"
        />
        {/* Right hook ascending (deep violet) */}
        <path
          d="M 32 20 Q 40 26, 46 18"
          stroke={`url(#g-violet-deep-${id})`}
          strokeWidth="5"
        />
      </g>
      {/* Junction dot — soft violet glow */}
      <circle cx="32" cy="20" r="1.5" fill="#E9D5FF" opacity="0.95" />
    </svg>
  );
};

export default Logo;
